import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoTasks = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 137,
	height: 105,
	viewBox: "0 0 137 105",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M120.974 79.9935C123.238 79.9935 125.074 78.1578 125.074 75.8935C125.074 73.6291 123.238 71.7935 120.974 71.7935C118.709 71.7935 116.874 73.6291 116.874 75.8935C116.874 78.1578 118.709 79.9935 120.974 79.9935Z",
			fill: "#F1F3F9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M113.1 91.4325C114.646 91.4325 115.9 90.1789 115.9 88.6325C115.9 87.0861 114.646 85.8325 113.1 85.8325C111.554 85.8325 110.3 87.0861 110.3 88.6325C110.3 90.1789 111.554 91.4325 113.1 91.4325Z",
			fill: "#F1F3F9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.3736 22.9934C23.92 22.9934 25.1736 21.7398 25.1736 20.1934C25.1736 18.647 23.92 17.3934 22.3736 17.3934C20.8272 17.3934 19.5736 18.647 19.5736 20.1934C19.5736 21.7398 20.8272 22.9934 22.3736 22.9934Z",
			fill: "#F1F3F9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.27361 76.9934C8.14549 76.9934 10.4736 74.6653 10.4736 71.7934C10.4736 68.9215 8.14549 66.5934 5.27361 66.5934C2.40173 66.5934 0.0736084 68.9215 0.0736084 71.7934C0.0736084 74.6653 2.40173 76.9934 5.27361 76.9934Z",
			fill: "#F1F3F9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.4236 103.093C96.4236 103.093 119.124 80.3934 119.124 52.2934C119.124 24.1934 96.4236 1.49341 68.4236 1.49341C40.4236 1.49341 17.7236 24.1934 17.7236 52.2934C17.7236 80.3934 40.4236 103.093 68.4236 103.093Z",
			fill: "#F1F3F9",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.8674 9.12891C99.3754 9.12891 100.651 10.2832 100.651 11.8993V93.6258C100.651 95.1264 99.4914 96.3962 97.8674 96.3962H37.4291C35.9211 96.3962 34.645 95.2418 34.645 93.6258V11.8993C34.645 10.3987 35.8051 9.12891 37.4291 9.12891H97.8674Z",
			fill: "#F1F3F9",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .3,
			d: "M100.651 17.671V93.5104C100.651 95.011 99.4915 96.2808 97.8674 96.2808H42.6493L37.7772 91.4326L92.6472 16.2858L97.4034 14.5543L100.651 17.671Z",
			fill: "#BCC4CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.6354 15.4778C97.6354 15.0161 97.2874 14.5543 96.7073 14.5543H38.7052C38.2412 14.5543 37.7772 14.9006 37.7772 15.4778V90.5092C37.7772 90.9709 38.1252 91.4326 38.7052 91.4326H96.5913C97.0554 91.4326 97.5194 91.0863 97.5194 90.5092L97.6354 15.4778Z",
			fill: "#F1F3F9",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.6354 15.4778C97.6354 15.0161 97.2874 14.5543 96.7074 14.5543H38.7052C38.2412 14.5543 37.7772 14.9006 37.7772 15.4778C38.4732 45.3749 38.7052 79.1967 35.4571 87.9696L91.0232 87.1616C94.3873 71.9245 96.9394 44.5669 97.6354 15.4778Z",
			fill: "#F1F3F9",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97.519 14.6697C97.519 14.6697 97.403 19.1716 96.0109 47.9143C96.0109 48.1452 96.0109 48.2606 96.0109 48.4915C94.2709 76.6571 69.2139 82.5442 66.1978 82.8905C64.8058 83.0059 62.1377 83.2368 57.3815 83.2368C51.4653 83.4677 42.4169 83.5831 28.2644 83.6985C27.8004 83.6985 27.4524 83.2368 27.6844 82.7751C37.4287 63.2669 37.5447 14.7851 37.5447 14.7851L97.519 14.6697Z",
			fill: "white",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M95.8953 48.3761C94.2712 76.5417 69.0983 82.4288 66.0822 82.7751C64.6901 82.8905 62.022 83.1214 57.2659 83.1214C69.7943 77.3497 76.5226 66.9608 76.4066 58.8805C82.4388 59.3422 92.8792 58.8805 95.8953 48.3761Z",
			fill: "#F1F3F9",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.7428 9.35976C81.7428 9.24433 81.7428 9.24433 81.7428 9.35976L81.1628 8.7826C81.1628 8.7826 80.8148 8.89803 80.6988 9.1289H71.6504C71.6504 8.89803 71.6504 8.7826 71.6504 8.55173C71.6504 6.70481 70.0264 5.08875 68.1703 5.08875C66.3143 5.08875 64.6902 6.70481 64.6902 8.55173C64.6902 8.7826 64.6902 8.89803 64.8062 9.01346H55.4098C54.9458 9.01346 54.4818 9.35976 54.4818 10.0524V13.0536C54.4818 15.3623 56.1059 16.7475 58.31 16.7475H77.5667C79.8868 16.7475 81.8588 15.3623 81.8588 13.0536V9.93693C81.9748 9.70606 81.8588 9.47519 81.7428 9.35976Z",
			fill: "#1C3754"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M81.3948 9.35985V12.3611C81.3948 12.592 81.3948 12.7074 81.3948 12.9383C81.0467 14.9006 79.4227 16.5167 77.3346 16.5167H57.9619C55.8738 16.5167 54.2497 14.9006 53.9017 12.9383C53.9017 12.7074 53.9017 12.592 53.9017 12.3611V9.35985C53.9017 8.89812 54.2497 8.32096 54.8298 8.32096H64.3421C64.3421 8.09009 64.3421 7.97466 64.3421 7.85923C64.3421 6.0123 65.9662 4.39624 67.8222 4.39624C69.6783 4.39624 71.3024 6.0123 71.3024 7.85923C71.3024 8.09009 71.3024 8.20553 71.3024 8.32096H80.8147C81.0467 8.43639 81.3948 8.78269 81.3948 9.35985Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.5902 9.47528C68.5183 9.47528 69.2143 8.78269 69.2143 7.85922C69.2143 6.93576 68.5183 6.24316 67.5902 6.24316C66.6622 6.24316 65.9662 6.93576 65.9662 7.85922C65.9662 8.78269 66.7782 9.47528 67.5902 9.47528Z",
			fill: "#F1F3F9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M52.0457 48.0298C53.9018 48.0298 55.2938 46.5292 55.2938 44.7977C55.2938 42.9507 53.7858 41.5656 52.0457 41.5656C50.1896 41.5656 48.7976 43.0662 48.7976 44.7977C48.6816 46.5292 50.1896 48.0298 52.0457 48.0298Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.7987 47.9144C79.6547 47.9144 81.0468 46.4138 81.0468 44.6823C81.0468 42.8354 79.5387 41.4502 77.7987 41.4502C76.0586 41.4502 74.5505 42.9508 74.5505 44.6823C74.5505 46.4138 75.9426 47.9144 77.7987 47.9144Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.0543 51.4928H61.79V52.9934H68.0543V51.4928Z",
			fill: "#AAB2C5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.581 15.016C133.133 27.021 132.785 39.7186 129.305 51.4928C128.493 53.9169 127.68 56.5718 125.94 58.4188C123.504 61.3046 119.096 62.5743 115.5 61.6509C111.788 60.7274 108.772 57.4953 108.076 53.5706C107.496 51.1465 108.308 48.2607 110.396 46.76C112.6 45.3748 115.732 45.7211 117.588 47.4526C119.676 49.1841 120.488 51.8391 120.372 54.3786C120.256 56.9181 119.328 59.4577 118.052 61.6509C114.224 68.8077 107.264 74.4639 99.2594 77.0035C93.3432 78.8504 86.963 78.8504 81.0468 77.2343",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeDasharray: "4 4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M135.453 11.553C135.105 12.8228 133.713 13.2845 132.321 12.4765C130.813 11.7839 129.769 11.2067 130.001 10.0524C130.349 8.89805 131.741 8.78261 133.365 8.66718C135.337 8.43632 135.685 10.2832 135.453 11.553Z",
			fill: "#F1F3F9",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M124.2 12.7073C124.78 13.7462 126.404 14.4388 127.564 13.3999C128.841 12.2456 129.885 11.4376 129.305 10.2832C128.725 9.24433 127.796 9.59063 125.824 9.82149C124.2 10.1678 123.504 11.553 124.2 12.7073Z",
			fill: "#F1F3F9",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M129.305 8.43638C130.117 8.32095 130.929 8.78268 131.161 9.47528C131.277 9.70614 131.393 10.0524 131.393 10.2833C131.625 11.8994 131.045 13.2846 130.117 13.4C129.073 13.6309 128.029 12.4765 127.913 10.9759C127.913 10.5142 127.913 10.2833 127.913 9.93701C128.029 9.12898 128.493 8.55181 129.305 8.43638C129.421 8.43638 129.305 8.43638 129.305 8.43638Z",
			fill: "#F1F3F9"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M129.305 8.43638C130.117 8.32095 130.929 8.78268 131.161 9.47528C131.277 9.70614 131.393 10.0524 131.393 10.2833C131.625 11.8994 131.045 13.2846 130.117 13.4C129.073 13.6309 128.029 12.4765 127.913 10.9759C127.913 10.5142 127.913 10.2833 127.913 9.93701C128.029 9.12898 128.493 8.55181 129.305 8.43638ZM129.305 8.43638C129.305 8.43638 129.421 8.43638 129.305 8.43638Z",
			stroke: "#D6DCE8",
			strokeWidth: 2,
			strokeMiterlimit: 10
		})
	]
});
export { SvgNoTasks as ReactComponent };
